import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [store, setStore] = useState("all");

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
    } catch { /* noop */ }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const toggleKill = async (val) => {
    const { data } = await api.post("/settings/kill-switch", { kill_switch: val });
    setSettings((s) => ({ ...s, kill_switch: data.kill_switch }));
    return data.kill_switch;
  };

  const setTrust = async (key, mode) => {
    const { data } = await api.post("/settings/trust", { key, mode });
    setSettings((s) => ({ ...s, trust: data.trust }));
  };

  return (
    <SettingsContext.Provider value={{ settings, refresh, toggleKill, setTrust, store, setStore }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
